// CommitChart.ts
import { TotalActivity } from '@luxtag/papybase';
import { map, max } from 'lodash';
import { Line, mixins } from 'vue-chartjs';
import { Component, Mixins, Model } from 'vue-property-decorator';

@Component({
    extends: Line, // this is important to add the functionality to your component
})
export default class TotalActivityLineChart extends Mixins(mixins.reactiveProp) {
    @Model('update:returnValue', {}) readonly value!: TotalActivity[];

    public option = {
        layout: {
            padding: {
                left: 40,
                right: 40,
                top: 40,
                bottom: 40,
            },
        },
        tooltips: {
            enable: true,
            callbacks: {
                label(tooltipItem: any, data: any) {
                    let label = data.datasets[tooltipItem.datasetIndex].label || '';

                    if (label) {
                        label += ': ';
                    }
                    label += Math.round(tooltipItem.yLabel * 100) / 100;
                    return label;
                },
            },
        },
        legend: {
            display: false,
        },
        scales: {
            yAxes: [{
                gridLines: {
                    display: true,
                },
                ticks: {
                    min: 0,
                    suggestedMax: 10,
                    stepSize: 2,
                },
            }],
            xAxes: [{
                gridLines: {
                    display: false,
                },
            }],
        },
        responsive: true,
        maintainAspectRatio: false,
        style: {
            height: '100px',
        },
    };

    mounted() {
        // Overwriting base render method with actual data.
        // @ts-ignore
        this.renderChart(this.chartData, this.option);
    }

    get lineHeight() {
        let maxCount = max(this.counts);

        if (!maxCount) maxCount = 0;

        if (maxCount < 6) {
            return 6;
        }
        return maxCount + 2;
    }

    get counts() {
        // @ts-ignore
        return map(this.value, a => a.count);
    }
}
